export default "__VITE_ASSET__BBvKAvPf__"